export default __webpack_public_path__ + "static/media/rectangles-no-4.66e7c9a2.mid";